import { render, staticRenderFns } from "./PinnacleData.vue?vue&type=template&id=04ec45a8&scoped=true&"
import script from "./PinnacleData.vue?vue&type=script&lang=js&"
export * from "./PinnacleData.vue?vue&type=script&lang=js&"
import style0 from "./PinnacleData.vue?vue&type=style&index=0&id=04ec45a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec45a8",
  null
  
)

export default component.exports